export default class Client {
    constructor() {
        this.withHeaders = (headers) => {
            Object.entries(headers).forEach(([key, value]) => {
                this.headers.append(key, value);
            });
            return this;
        };
        this.get = (url, query) => {
            url = this.appendQuery(url, query);
            return this.fetch(url, 'get');
        };
        this.post = (url, data = {}) => {
            return this.fetch(url, 'post', data);
        };
        // public patch = (url: string, data: object = {}) => {
        //   return this.fetch(url, 'patch', data)
        // }
        //
        // public delete = (url: string, data: object = {}) => {
        //   return this.fetch(url, 'delete', data)
        // }
        this.fetch = async (url, method, data = {}) => {
            if (method !== 'get') {
                this.headers.append('Content-Type', 'application/json');
            }
            const init = {
                headers: this.headers,
                method,
            };
            if (!this.isEmpty(data)) {
                init.body = JSON.stringify(data);
            }
            const response = await fetch(url, init);
            if (response.status === 204) {
                return;
            }
            const responseData = await this.getResponseBody(response);
            if (!response.ok) {
                const message = `Error ${response.status}: ${response.statusText}`;
                throw new RequestError(message, responseData);
            }
            return responseData;
        };
        this.getResponseBody = async (response) => {
            const responseClone = response.clone();
            try {
                return await response.json();
            }
            catch (error) { }
            try {
                return await responseClone.text();
            }
            catch (error) { }
        };
        this.appendQuery = (url, query) => {
            const _url = new URL(url);
            Object.entries(query).map(([key, value]) => {
                if (Array.isArray(value)) {
                    value.map((item) => _url.searchParams.append(`${key}[]`, item));
                }
                else if (value instanceof Object) {
                    Object.entries(value).map(([_key, _value]) => _url.searchParams.append(`${key}[${_key}]`, _value));
                }
                else {
                    _url.searchParams.append(key, value);
                }
            });
            return _url.toString();
        };
        this.isEmpty = (data) => {
            return Object.keys(data).length === 0;
        };
        this.headers = new Headers();
    }
}
class RequestError extends Error {
    constructor(message, data) {
        super(message);
        this.data = data;
    }
}
